module.exports = __webpack_public_path__ + "img/0Q3A4704_L.ed238473.webp";